import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface FoxApisModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FoxApisModal({ open, onOpenChange }: FoxApisModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>FoxAPIs — Our Sister Product</DialogTitle>
          <DialogDescription className="pt-2 text-sm leading-relaxed">
            FoxAPIs offers 51 web intelligence APIs, API combinations, and AI agent blueprints. Built for developers who want structured data from anywhere on the web.
            {" "}FoxAPIs is not included in MentionFox plans — and you don't need a MentionFox plan to use it.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button asChild className="flex-1">
            <a href="https://foxapis.com" target="_blank" rel="noopener noreferrer">
              Explore FoxAPIs <ArrowRight className="w-4 h-4 ml-1" />
            </a>
          </Button>
          <Button asChild variant="outline" className="flex-1">
            <a href="https://foxapis.com/#pricing" target="_blank" rel="noopener noreferrer">
              View Pricing <ArrowRight className="w-4 h-4 ml-1" />
            </a>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
